/** @jsx isolateComponent */
import { css } from '@emotion/core';

import { KindDisplayNameType } from '@zapier/product-get-help/src/types';

import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Icon, Typography } from '@zapier/design-system';

import SkipButton from '@zapier/product-get-help/src/components/shared/SkipButton';

import FolderGroup from '../FolderGroup';

import { DataType, ZapType } from '../useData';

type BrowserProps = {
  data: DataType;
  isFiltered: boolean;
  kindDisplayName: KindDisplayNameType;
  onSelect: (item: ZapType | null) => void;
};

const emptyCss = css`
  height: 330px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
`;

const emptyTextCss = () => css`
  ${Typography.sectionHeader3}
  font-weight: 600;
  color: ${Colors.neutral800};
  margin-top: 20px;
`;

const rootCss = css`
  display: grid;
  grid-gap: 30px;
`;

/** Renders all groups of folders with Zaps for `<Open>`. */
const Browser = ({
  data,
  isFiltered,
  kindDisplayName,
  onSelect,
}: BrowserProps) => {
  const hasData = data.length > 0;

  return (
    <div css={rootCss}>
      <SkipButton onSelect={onSelect}>
        {`I don’t need help with a specific ${kindDisplayName}`}
      </SkipButton>
      {hasData ? (
        <ol>
          {data.map(group => (
            <FolderGroup
              forceFoldersOpen={isFiltered}
              key={group.title}
              onSelect={onSelect}
              {...group}
            />
          ))}
        </ol>
      ) : (
        <div css={emptyCss}>
          <Icon color={'neutral800'} name="navSearch" size={64} />
          <span css={emptyTextCss()}>No Results</span>
        </div>
      )}
    </div>
  );
};

export default Browser;
